import type { ApiAppConfig } from '../../api/types'
import type { GlobalState } from '../types'

export const selectAppConfig = (global: GlobalState) => global.appConfig

export const selectEnableFeatures = (global: GlobalState): ApiAppConfig['enableFeatures'] => {
  const appConfig = selectAppConfig(global)

  if (!appConfig) {
    return {}
  }

  return appConfig.enableFeatures
}

export const selectIsLoginQrFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).LOGIN_QR ?? false
}

export const selectIsGroupsStatsFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).GROUPS_STATS ?? false
}

export const selectIsChannelsInviteLinksFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).CHANNELS_INVITE_LINKS ?? false
}

export const selectIsChannelsSaveRestrictFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).CHANNELS_SAVE_RESTRICT ?? false
}

export const selectIsThreadsTopicsFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).THREADS_TOPICS ?? false
}

export const selectIsPrivacyFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).PRIVACY ?? false
}

export const selectIsPrivacyCallsFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).PRIVACY_CALLS ?? false
}

export const selectIsPrivacyExceptionsFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).PRIVACY_EXCEPTIONS ?? false
}

export const selectIsSilentMessagesFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).SILENT_MESSAGES ?? false
}

export const selectIsSendWhenOnlineFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).SEND_WHEN_ONLINE ?? false
}

export const selectIsDevicesTtlFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).DEVICES_TTL ?? false
}

export const selectIsBotsFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).BOTS ?? false
}

export const selectIsStickerBotFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).STICKER_BOT ?? false
}

export const selectIsCommonChatsTabFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).COMMON_CHATS_TAB ?? false
}

export const selectIsUploadWallpapersFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).UPLOAD_WALLPAPERS ?? false
}

export const selectIsMarkAsUnreadFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).MARK_AS_UNREAD ?? false
}

export const selectIsContactsSuggestPhotoFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).CONTACTS_SUGGEST_PHOTO ?? false
}

export const selectIsLiveStreamsFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).LIVE_STREAMS ?? false
}

export const selectIsFavoriteStickersFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).FAVORITE_STICKERS ?? false
}

export const selectIsGroupCallsFeatureEnabled = (global: GlobalState): boolean => {
  return selectEnableFeatures(global).CALLS_GROUP ?? false
}
